'use client';
import { AltertTriangle, LocationNotAllowed } from '../../../../public/Images';
import Typography from '@/components/shared/typography/typography.component';
import styles from './styles.module.scss';
import Image from 'next/image';
import colors from '@/theme/colors.module.scss';

type DisclaimerVariant = 'warning' | 'error';
interface IDisclaimer {
    variant?: DisclaimerVariant;
    text?: string;
}

const Disclaimer = ({ text, variant = 'warning' }: IDisclaimer) => {
    return (
        <div className={`${styles.disclaimer_container} ${styles[variant]}`}>
            <Image
                style={{ width: '24px' }}
                src={variant === 'error' ? LocationNotAllowed : AltertTriangle}
                alt="disclaimer"
            />
            <Typography
                color={
                    variant === 'error' ? colors.error600 : colors.warning700
                }
                variant="captionMedium"
            >
                {text}
            </Typography>
        </div>
    );
};
export default Disclaimer;
